// extracted by mini-css-extract-plugin
var _1 = "mqo7ENj7";
var _2 = "mqo7ENj7";
var _3 = "_AFUXWJC";
var _4 = "V2JvBVP4";
var _5 = "V2JvBVP4";
var _6 = "eQjMWfY2";
var _7 = "eQjMWfY2";
export { _1 as "next-button", _2 as "nextButton", _3 as "overflow", _4 as "previous-button", _5 as "previousButton", _6 as "scrollable-div", _7 as "scrollableDiv" }
